export default __webpack_public_path__ + "static/media/048-ladder.7867ac35.png";